import { ActionTypes } from "../constants/actionType";

export const setConsoleCategory = (category: string) => {
  return {
    type: ActionTypes.SET_CONSOLE_CATEGORY,
    payload: category,
  };
};
